'use strict';

// WebphoneUI class

// Prefixes:
//  evt - DOM event
//  pe - phone event
//  on - any other event
function WebphoneUI() {
    this.maxVLineId = 3;

    this.l = WebphoneLogger.factory();
    this.phone = new Webphone({
        'vLines' : this.maxVLineId,
        'logger' : this.l
    });

    this.phone.setSoundRootUrl('/webphone/sounds/');
    
    this.mw = new WebphoneModalWindow({
        'logger' : this.l
    });
    this.mwAudio = new WebphoneModalWindow({
        'logger' : this.l
    });
    this.mwAudio.bgSelector = '.window-modal-audio-bg';
    this.mwAudioStream = new WebphoneModalWindow({
        'logger' : this.l
    });
    this.mwAudioStream.bgSelector = '.window-modal-audiostream-bg';
    this.sipLogin = '';
    this.sipPassword = '';
    this.audioSoundPleer;
    this.audioStreamPleer;
    this.muteMic = false;
    this.micLevel = 100;
    this.soundLevel = 100;
    this.ringLevel = 100;

    this.vLines;
    this.clockUpdateInterval;

    this.doingTransfer;

    this.settingsInitialized = false;

    this.callHistoryKey = 'webphone-call-history';
    this.callHistory;
    this.callHistoryChanged = false;

    this.loadHistory();
};

WebphoneUI.prototype.translateBlock = function(block) {
    var _this = this;

    jQuery(block).find('*[data-html]').each(function(i,el){
        jQuery(el).html(_this.translate(jQuery(el).attr('data-html')));
        jQuery(el).removeAttr('data-html');
    });
    jQuery(block).find('*[data-value]').each(function(i,el){
        jQuery(el).val(_this.translate(jQuery(el).attr('data-value')));
        //jQuery(el).removeAttr('data-value');
    });
};

// https://stackoverflow.com/questions/1787322/htmlspecialchars-equivalent-in-javascript
WebphoneUI.prototype._escapeHtml = function(text) {
  var map = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;'
  };

  return text.replace(/[&<>"']/g, function(m) { return map[m]; });
};

WebphoneUI.prototype.wait = function(timeout) {
    return new Promise(function(resolve, reject) {
	setTimeout(() => {
	    resolve(1);
	}, timeout);
    });
};

WebphoneUI.prototype.vl = function(vLineId) {
    if (!this.vLines)
        this.vLines = {};

    var id = vLineId ? vLineId : this.phone.getActiveVLineId();

    if (!this.vLines[id])
        this.vlClear(id);

    return this.vLines[id];
};

WebphoneUI.prototype.vlClear = function(vLineId) {
    if (!this.vLines)
        this.vLines = {};

    this.vLines[vLineId] = {
        callStarted : null,
        talkStarted : null,
        holdStarted : null,
        //lastFailedSession : null,
        callee : '',
        infoLine : '',
        //updatedToState : null,
        inTransfer : false,
        isIncoming : false,
    };
};

WebphoneUI.prototype.login = function(evt) {
    this.debug('login', 'called');

    this.phone.login({
        login  : this.sipLogin,
        password : this.sipPassword,
    });
};



/**
 * Window :: Main
 */
WebphoneUI.prototype.updateUI = function() {
    this.debug('updateUI', 'called');

    if (this.phone.isRegistered()) {
        jQuery('.webphone .header .btn-login').hide();
        jQuery('.webphone .header .btn-logout').show();
        jQuery('.webphone .header .userinfo').html(this.sipLogin);
    } else {
        jQuery('.webphone .header .btn-login').show();
        jQuery('.webphone .header .btn-logout').hide();
        jQuery('.webphone .header .userinfo').html('');
    }

    var state = this.phone.getState();

    // Update callee from vl()
    //jQuery('.webphone input[name="callee"]').val(this.vl().callee);

    // Update infoline from vl()
    this.updateInfoLine(this.vl().infoLine);
    
    // Clear info time
    this.updateInfoTime('');

    // Close all modal windows
    this.mw.close('on update UI');

    switch (state) {
    case '':
    case 'ready':
        jQuery('.webphone .btn-hangup').hide();
        jQuery('.webphone .btn-call').show();
        jQuery('.webphone .screen input').removeAttr('disabled');
        jQuery('.webphone .btn-hold').addClass('disabled').removeClass('selected');
        jQuery('.webphone .btn-transfer').addClass('disabled');
        this.stopClock();
        break;
    case 'calling':
        jQuery('.webphone .screen input').attr('disabled','disabled');
        jQuery('.webphone .btn-hangup').show();
        jQuery('.webphone .btn-call').hide();
        jQuery('.webphone .btn-hold').addClass('disabled').removeClass('selected');
        jQuery('.webphone .btn-transfer').addClass('disabled');
        this.showClock('call');
        break;
    case 'incoming':
        jQuery('.webphone .screen input').attr('disabled','disabled');
        jQuery('.webphone .btn-hangup').show();
        jQuery('.webphone .btn-call').hide();
        jQuery('.webphone .btn-hold').addClass('disabled').removeClass('selected');
        jQuery('.webphone .btn-transfer').addClass('disabled');
        //jQuery('.webphone .btn-hold').removeClass('disabled').removeClass('selected');
        //jQuery('.webphone .btn-transfer').removeClass('disabled');
        this.showClock('call');
        this.showIncomingWindow(this.phone.getActiveVLineId(), this.vl().callee);
        break;
    case 'talk':
        jQuery('.webphone .screen input').attr('disabled','disabled');
        jQuery('.webphone .btn-hangup').show();
        jQuery('.webphone .btn-call').hide();
        jQuery('.webphone .btn-hold').removeClass('disabled').removeClass('selected');
        jQuery('.webphone .btn-transfer').removeClass('disabled');
        this.showClock('talk');
        break;
    case 'hold':
        jQuery('.webphone .screen input').attr('disabled','disabled');
        jQuery('.webphone .btn-hangup').show();
        jQuery('.webphone .btn-call').hide();
        jQuery('.webphone .btn-hold').removeClass('disabled').addClass('selected');
        jQuery('.webphone .btn-transfer').removeClass('disabled');
        this.showClock('hold');
        break;
    }

    // Update states of vline buttons
    for (var vLineId = 1; vLineId <= this.maxVLineId; vLineId++) {

        state = this.phone.getState(vLineId);

        switch (state) {
        case '':
        case 'ready':
            jQuery('.webphone .vlines li:nth-child(' + vLineId + ')').removeClass('calling incoming talk hold');
            break;
        case 'calling':
            jQuery('.webphone .vlines li:nth-child(' + vLineId + ')').removeClass('incoming talk hold').addClass('calling');
            break;
        case 'incoming':
            jQuery('.webphone .vlines li:nth-child(' + vLineId + ')').removeClass('calling talk hold').addClass('incoming');
            break;
        case 'talk':
            jQuery('.webphone .vlines li:nth-child(' + vLineId + ')').removeClass('calling incoming hold').addClass('talk');
            break;
        case 'hold':
            jQuery('.webphone .vlines li:nth-child(' + vLineId + ')').removeClass('calling incoming talk').addClass('hold');
            break;
        }
    }

    // Update clock right now
    this.evtUpdateClock();
};

WebphoneUI.prototype.updateInfoLine = function(text) {
    jQuery('.webphone .screen .info .line').text(text);
};

WebphoneUI.prototype.updateInfoTime = function(text) {
    jQuery('.webphone .screen .info .time').text(text);
};

WebphoneUI.prototype.evtLogout = function(evt) {
    this.debug('evtLogout', 'called');

    evt.stopPropagation();

    this.phone.logout();

    return false;
};

WebphoneUI.prototype.evtClickMicBtn = function(evt) {
    this.debug('evtClickMicBtn', 'called');

    evt.preventDefault();

    this.muteMic = !this.muteMic;

    if (this.muteMic)
        this.phone.muteMic();
    else
        this.phone.unmuteMic();

    this.evtMicMute();

    return false;
};

WebphoneUI.prototype.evtClickHoldBtn = function(evt) {
    this.debug('evtClickHoldBtn', 'called');

    evt.preventDefault();

    var state = this.phone.getState();

    switch (state) {
    case 'talk':
    //case 'incoming':
        this.phone.hold();
        break;
    case 'hold':
        this.phone.unhold();
        break;
    default:
        this.debug('evtClickHoldBtn', 'do nothing for state= ' + state);
        break;
    }

    return false;
};

WebphoneUI.prototype.evtClickTransferBtn = function(evt) {
    this.debug('evtClickTransferBtn', 'called');

    evt.preventDefault();

    var state = this.phone.getState();

    switch (state) {
    case 'talk':
    case 'hold':
    //case 'incoming':
        this.showTransferWindow();
        break;
    default:
        this.debug('evtClickTransferBtn', 'do nothing for state= ' + state);
        break;
    }

    return false;
};

// Internal event to change all states when mic is muted
WebphoneUI.prototype.evtMicMute = function() {

    if (this.muteMic) {

        // Update screen mic button
        jQuery('.webphone .btn-mic').removeClass('icon-mic').addClass('icon-mic_off');

        // Settings window
        jQuery('.webphone .window-settings .micro .icon').removeClass('icon-mic').addClass('icon-mic_off');

        if (jQuery('.webphone .window-settings .micro .slider').data('uiSlider'))
            jQuery('.webphone .window-settings .micro .slider').slider('value', 0);
        
    } else {

        // Update screen mic button
        jQuery('.webphone .btn-mic').removeClass('icon-mic_off').addClass('icon-mic');

        // Settings window
        jQuery('.webphone .window-settings .micro .icon').removeClass('icon-mic_off').addClass('icon-mic');

        if (jQuery('.webphone .window-settings .micro .slider').data('uiSlider'))
            jQuery('.webphone .window-settings .micro .slider').slider('value', this.micLevel);
    }
};

WebphoneUI.prototype.evtSelectLine = function(evt) {
    this.debug('evtSelectLine', 'called');

    evt.preventDefault();

    var lineId = parseInt(jQuery(evt.currentTarget).attr('data-idx'));

    this.phone.selectVLine(lineId);

    return false;
};

WebphoneUI.prototype.evtCall = function(evt) {
    this.debug('evtCall', 'called');

    if (evt)
        evt.stopPropagation();

    var callee = jQuery('.webphone input[name="callee"]').val();

    if (!callee.length) {
        this.showInfoWindow(this.translate('E_CalleeIsEmpty'), {autoClose:3000, lock: false});
        return;
    }

    if (!callee.match(/^\*?\d+$/g)) {
        this.showInfoWindow(this.translate('E_CalleeIsNotNumber'), {autoClose:3000, lock: false});
        return;
    }

    this.vl().callee = callee;

    // Call
    try {
        this.phone.call(callee);
    } catch (error) {
        this.l.error('evtCall', 'call caught a error: ' + this.l._dumpError(error));

        if (typeof error.message !== 'undefined')
            this.showInfoWindow(this.translate(error.message), {autoClose:3000, lock: true});
        else if (typeof error.name !== 'undefined')
            this.showInfoWindow(this.translate('UserMediaException_'+error.name), {autoClose:3000, lock: true});
        else
            this.showInfoWindow(this.translate('E_NoAccessMicrophone'), {autoClose:3000, lock: true});
    }

    return false;
};

WebphoneUI.prototype.evtHangup = function(evt) {

    this.debug('evtHangup', 'called');

    evt.stopPropagation();

    //if (this.phone.getState() === 'talk')
    //this.phone.terminateSessions();

    this.phone.terminateSession();

    return false;
};

WebphoneUI.prototype.evtClickKeypad = function(evt) {

    evt.stopPropagation();

    var buttonVal = jQuery(evt.currentTarget).attr('data-value');

    this.debug('evtClickKeypad', 'called' + (typeof buttonVal !== 'undefined' ? ('. buttonVal= ' + buttonVal) : ''));

    if (typeof buttonVal !== 'undefined' ) {

        switch (this.phone.getState()) {
        case '':
        case 'ready':
            var calleeElement = jQuery('.webphone .screen input[name="callee"]');
            var callee = calleeElement.val() + buttonVal;
            calleeElement.val(callee);

            this.vl().callee = callee;

            // Move cursor to the end of the input field
            //callee.prop('selectionStart', callee.val().length);
            //callee.prop('selectionEnd', callee.val().length);
            //callee.focus();
            break;
            //case 'calling':
            //case 'incoming':
            //case 'hold':
        case 'talk':
            var calleeElement = jQuery('.webphone .screen input[name="callee"]');
            var ext = calleeElement.val() + buttonVal;
            calleeElement.val(ext);

            this.vl().ext = ext;

            // Move cursor to the end of the input field
            //callee.prop('selectionStart', callee.val().length);
            //callee.prop('selectionEnd', callee.val().length);
            //callee.focus();

            // Send DTMF
            this.phone.sendDTMF(buttonVal);
            break;
        }
    }

    return false;
};

WebphoneUI.prototype.evtClickBackspace = function(evt) {

    evt.stopPropagation();

    switch (this.phone.getState()) {
    case '':
    case 'ready':
        var calleeElement = jQuery('.webphone .screen input[name="callee"]');
        var callee = calleeElement.val().replace(/.$/g, '');

        calleeElement.val(callee);

        this.vl().callee = callee;
        break;
    case 'talk':
        var calleeElement = jQuery('.webphone .screen input[name="callee"]');
        var ext = calleeElement.val().replace(/.$/g, '');

        calleeElement.val(ext);

        this.vl().ext = ext;
        break;
    }

    // Move cursor to the end of the input field
    calleeElement.prop('selectionStart', callee.length);
    calleeElement.prop('selectionEnd', callee.length);
    calleeElement.focus();

    return false;
};



/**
 * Clock
 */
WebphoneUI.prototype.showClock = function(type) {
    var _this = this;

    if (!this.clockUpdateInterval)
        this.clockUpdateInterval = setInterval(function() {
            _this.evtUpdateClock();
        }, 900);
};

WebphoneUI.prototype.stopClock = function() {
    if (this.clockUpdateInterval) {
        clearInterval(this.clockUpdateInterval);
        this.clockUpdateInterval = null;
    }
};

WebphoneUI.prototype.getTimeDiff = function(time) {

    var zeroFillData = '0000000000';  // max number of zero fill ever asked for in global

    var zeroFill = function(number, width) {
        var input = number + '';  // make sure it's a string
        return(zeroFillData.slice(0, width - input.length) + input);
    };

    var now = new Date();

    var timeDiff = Math.floor((now.getTime() - time.getTime()) / 1000);

    //this.debug('getTimeDiff', 'timeDiff= ' + timeDiff);

    var ss = timeDiff - Math.floor(timeDiff / 60)*60;
    timeDiff = (timeDiff - ss) / 60;
    var mm = timeDiff - Math.floor(timeDiff / 60)*60;
    timeDiff = (timeDiff - mm) / 60;
    var hh = timeDiff - Math.floor(timeDiff / 24)*24;
    timeDiff = (timeDiff - hh) / 24;
    var DD = timeDiff;

    var DDDhhmmss = ''
        + (DD ? (zeroFill(DD, 3) + ' ') : '')
        + (hh ? (zeroFill(hh, 2) + ':') : '')
        + zeroFill(mm, 2) + ':'
        + zeroFill(ss, 2);

    return DDDhhmmss;
};

WebphoneUI.prototype.evtUpdateClock = function() {
    if (this.vl().holdStarted)
        this.updateInfoTime(this.getTimeDiff(this.vl().holdStarted));
    else if (this.vl().talkStarted)
        this.updateInfoTime(this.getTimeDiff(this.vl().talkStarted));
    else if (this.vl().callStarted)
        this.updateInfoTime(this.getTimeDiff(this.vl().callStarted));
    else
        this.updateInfoTime('');
};


/**
 * Window :: Settings
 */
WebphoneUI.prototype.evtOpenSettingsWindow = function(evt) {
    this.debug('openSettingsWindow', 'called');

    var _this = this;

    evt.preventDefault();

    // Initialize only once
    if (!this.settingsInitialized) {

        this.settingsInitialized = true;

        // Check if it is possible to manage micStream volume
        if (this.phone.canManageMicStream()) {

            jQuery('.webphone .window-settings .micro .slider').slider({
                value: 100,
                orientation: 'horizontal',
                range: 'min',
                animate: true,
                slide: function(evt, ui) {
                    if (ui.value == 0) {

                        if (!_this.muteMic) {
                            _this.muteMic = true;
                            _this.phone.muteMic();
                            _this.evtMicMute();
                        }

                    } else {

                        if (_this.muteMic) {
                            _this.muteMic = false;
                            _this.phone.unmuteMic();
                            _this.evtMicMute();
                        }
                    }

                    _this.micLevel = ui.value;
                    _this.phone.setMicLevel.apply(_this.phone, [ui.value]);
                }
            });

            jQuery('.webphone .window-settings .micro .icon').click(function(evt) {

                _this.muteMic = !_this.muteMic;

                if (_this.muteMic)
                    _this.phone.muteMic();
                else
                    _this.phone.unmuteMic();

                _this.evtMicMute();
            });

        } else {
            jQuery('.webphone .window-settings .micro').hide();
        }

        jQuery('.webphone .window-settings .sound .slider').off();
        jQuery('.webphone .window-settings .sound .slider').slider({
            value: 100,
            orientation: 'horizontal',
            range: 'min',
            animate: true,
            slide: function(event, ui) {
                if (ui.value == 0) {
                    if (jQuery('.webphone .window-settings .sound .icon').hasClass('icon-volume_up')) {
                        jQuery('.webphone .window-settings .sound .icon').removeClass('icon-volume_up').addClass('icon-volume_off');
                    }
                } else {
                    if (jQuery('.webphone .window-settings .sound .icon').hasClass('icon-volume_off')) {
                        jQuery('.webphone .window-settings .sound .icon').removeClass('icon-volume_off').addClass('icon-volume_up');
                    }
                }
                
                _this.soundLevel = ui.value;
                _this.phone.setRemoteAudioLevel.apply(_this.phone, [ui.value]);
            }
        });

        jQuery('.webphone .window-settings .sound .icon').click(function(evt) {
            if (jQuery('.webphone .window-settings .sound .icon').hasClass('icon-volume_up')) {
                jQuery('.webphone .window-settings .sound .icon').removeClass('icon-volume_up').addClass('icon-volume_off');
                _this.phone.muteRemoteAudio();
                jQuery('.webphone .window-settings .sound .slider').slider('value', 0);
            } else {
                jQuery('.webphone .window-settings .sound .icon').removeClass('icon-volume_off').addClass('icon-volume_up');
                _this.phone.unmuteRemoteAudio();
                jQuery('.webphone .window-settings .sound .slider').slider('value', _this.soundLevel);
            }
        });

        jQuery('.webphone .window-settings .ring .slider').off();
        jQuery('.webphone .window-settings .ring .slider').slider({
            value: 100,
            orientation: 'horizontal',
            range: 'min',
            animate: true,
            slide: function(event, ui) {
                if (ui.value == 0) {
                    if (jQuery('.webphone .window-settings .ring .icon').hasClass('icon-notifications_active')) {
                        jQuery('.webphone .window-settings .ring .icon').removeClass('icon-notifications_active').addClass('icon-notifications_off');
                    }
                } else {
                    if (jQuery('.webphone .window-settings .ring .icon').hasClass('icon-notifications_off')) {
                        jQuery('.webphone .window-settings .ring .icon').removeClass('icon-notifications_off').addClass('icon-notifications_active');
                    }
                }
                
                _this.ringLevel = ui.value;
                _this.phone.setSoundLevel.apply(_this.phone, [ui.value]);
            }
        });

        jQuery('.webphone .window-settings .ring .icon').click(function(evt) {
            if (jQuery('.webphone .window-settings .ring .icon').hasClass('icon-volume_up')) {
                jQuery('.webphone .window-settings .ring .icon').removeClass('icon-volume_up').addClass('icon-volume_off');
                _this.phone.muteSound();
                jQuery('.webphone .window-settings .ring .slider').slider('value', 0);
            } else {
                jQuery('.webphone .window-settings .ring .icon').removeClass('icon-volume_off').addClass('icon-volume_up');
                _this.phone.unmuteSound();
                jQuery('.webphone .window-settings .ring .slider').slider('value', _this.ringLevel);
            }
        });

        jQuery('.webphone .window-settings input[name="debugmode"]').change(function(evt) {
            if (jQuery(evt.currentTarget).prop('checked')) {
                JsSIP.debug.enable('JsSIP:*');
                _this.l.enabled = true;
                _this.debug('openSettingsWindow', 'debugmode enabled');
            } else {
                _this.debug('openSettingsWindow', 'debugmode disabled');
                JsSIP.debug.disable('JsSIP:*');
                _this.l.trace = false;
            }
        });
    }

    this.mw.open('settings',{closeBtn:true, closeBg:true, closeEsc:true, onClose:this.onCloseSettingsWindow});

    return false;
};

WebphoneUI.prototype.onCloseSettingsWindow = function() {
    this.debug('onCloseLoginWindow', 'called');

    jQuery('.webphone .window-settings input[name="debugmode"]').off();
};



/**
 * Call history
 */
WebphoneUI.prototype.loadHistory = function() {
    this.debug('loadHistory', 'called');

    var data = localStorage.getItem(this.callHistoryKey);

    if (typeof data === 'string'
        && data) {
        try {
            this.callHistory = JSON.parse(data);
        } catch (error) {
            this.callHistory = [];
        }
    }

    this.callHistoryChanged = false;
};

WebphoneUI.prototype.saveHistory = function(vLineId, result, cause) {
    this.debug('saveHistory', 'called');

    var maxHistoryLength = 50; // Keep history length no more than this size
    var callHistoryLength = this.callHistory ? this.callHistory.length : 0;

    if (callHistoryLength > maxHistoryLength)
        this.callHistory.splice(0, callHistoryLength - maxHistoryLength);

    localStorage.setItem(this.callHistoryKey, JSON.stringify(this.callHistory));
    this.callHistoryChanged = false;
};

WebphoneUI.prototype.addToHistory = function(vLineId, result, cause) {
    this.debug('addToHistory', 'called. vLineId= ' + vLineId
               + (result
                  ? (', result= ' + result)
                  : '')
               + (cause
                  ? (', cause= ' + cause)
                  : '')
              );

    var rec = {
        'result' : result,
        'number' : this.vl(vLineId).callee,
        'time' : this.vl(vLineId).callStarted.toISOString(),
    };

    if (result === 'success')
        rec.duration = Math.floor(((new Date()).getTime() - this.vl(vLineId).callStarted.getTime()) / 1000);

    if (this.vl(vLineId).isIncoming)
        rec.isIncoming = true;

    if (cause)
        rec.cause = cause;

    if (typeof this.callHistory !== 'object'
        || !Array.isArray(this.callHistory))
        this.callHistory = [];

    this.callHistory.push(rec);
    this.callHistoryChanged = true;
};

WebphoneUI.prototype.evtOpenHistoryWindow = function(evt) {
    this.debug('evtOpenHistoryWindow', 'called');

    var _this = this;

    evt.preventDefault();

    // Fill history
    if (typeof this.callHistory === 'object'
        && Array.isArray(this.callHistory)) {

        var historyHtml = '';
        var lastDate = '';
        var _zeroFillData = '0000000000';
        var rowEven = false;

        var zeroFill = function(number, width) {
            var input = number + '';  // make sure it's a string

            if (width > input.length)
                return _zeroFillData.slice(0, width - input.length) + input;
            else
                return input;
        };

        var encodedToHtml = function(text) {
            var html = text.replace(/[\u00A0-\u9999<>\&"]/g, function(i) {
                return '&#' + i.charCodeAt(0) + ';';
            });
            return html;
        };

        var callHistoryLength = this.callHistory.length;

        for (var i = callHistoryLength - 1; i >= 0; i--) {
            var v = this.callHistory[i];

            // Time
            var timeObj = new Date(v.time);

            var dd = zeroFill(timeObj.getDate(), 2);
            var mm = zeroFill(timeObj.getMonth() + 1, 2); // Months are zero-based
            var yyyy = timeObj.getFullYear();

            var date = yyyy + '-' + mm + '-' + dd;

            var HH = zeroFill(timeObj.getHours(), 2);
            var MM = zeroFill(timeObj.getMinutes(), 2);
            var SS = zeroFill(timeObj.getSeconds(), 2);

            var time = HH + ':' + MM + ':' + SS;
            var timeShort = HH + ':' + MM;

            if (date !== lastDate) {
                historyHtml += '<li class="date">'
                    + date
                    + '</li>';

                rowEven = false;

                lastDate = date;
            }

            // Icon & title
            var historyIcon = '';
            var historyTitle = '';
            var callType = '';

            switch (v.result) {

            case 'success':
                if (v.isIncoming) {
                    historyIcon = 'icon-call_received';
                    historyTitle = this.translate('T_HistoryTitleIncoming');
                    callType = 'incoming';
                } else {
                    historyIcon = 'icon-call_made';
                    historyTitle = this.translate('T_HistoryTitleOutgoing');
                    callType = 'outgoing';
                }
                break;

            case 'fail':
                if (v.isIncoming) {
                    historyIcon = 'icon-call_missed';
                    callType = 'missed';
                } else {
                    historyIcon = 'icon-call_missed_outgoing';
                    callType = 'cancelled';
                }

                if (v.cause) {
                    if (this.translate('CallCause_' + v.cause) !== 'CallCause_' + v.cause)
                        historyTitle = this.translate('CallCause_' + v.cause);
                    else
                        historyTitle = v.cause;
                } else {
                    if (v.isIncoming)
                        historyTitle = this.translate('T_HistoryTitleIncoming');
                    else
                        historyTitle = this.translate('T_HistoryTitleOutgoing');
                }
                break;
            }
            historyIcon += '"';

            // Duration
            var duration = '';
            var durationShort = '';
            if (v.duration) {
                var durationTmp = v.duration;

                SS = durationTmp - Math.floor(durationTmp / 60)*60;
                durationTmp = (durationTmp - SS) / 60;
                MM = durationTmp - Math.floor(durationTmp / 60)*60;
                durationTmp = (durationTmp - MM) / 60;
                HH = durationTmp;

                duration = zeroFill(HH, 2) + ':'
                + zeroFill(MM, 2) + ':'
                + zeroFill(SS, 2);


                MM = (v.duration - SS) / 60;

                durationShort = zeroFill(MM, 2) + ':'
                    + zeroFill(SS, 2);
            }

            if (callType
                && v.number) {
                historyTitle += ' ';
                switch (callType) {
                case 'incoming':
                    historyTitle += this.translate('T_HistoryTitleIncomingNumber');
                    break;
                case 'outgoing':
                    historyTitle += this.translate('T_HistoryTitleOutgoingNumber');
                    break;
                case 'missed':
                    historyTitle += this.translate('T_HistoryTitleMissedNumber');
                    break;
                case 'cancelled':
                    historyTitle += this.translate('T_HistoryTitleCancelledNumber');
                    break;
                }
                historyTitle += ' "' + v.number + '"';
            }

            if (duration) {
                historyTitle += ' '
                    + this.translate('T_HistoryTitleDuration')
                    + ' '
                    + duration;
            }

            if (time) {
                historyTitle += ', '
                    + this.translate('T_HistoryTitleTime')
                    + ': '
                    + time;
            }

            // Build html row
            historyHtml += '<li class="row'
                + (rowEven
                   ? ' even'
                   : ' odd')
                + '"'
                + (historyTitle
                   ? (' title="' + encodedToHtml(historyTitle) + '"')
                   : '')
                + '>'
                + '<span class="time">' + timeShort + '</span>'
                + '<span class="number">'
                + '<span class="icon'
                + (historyIcon
                   ? (' ' + historyIcon)
                   : '')
                + '">'
                + '</span>'
                + '<a class="callback" href="#' + v.number + '" title="' + this.translate('BT_HistoryCall') + ' ' + this._escapeHtml(v.number) + '">' + v.number + '</a>'
                + '</span>'
                + (durationShort
                   ? ('<span class="duration">' + durationShort + '</span>')
                   : '')
                + '</li>';

            rowEven = !rowEven;
        }

        if (historyHtml)
            jQuery('.window-modal.window-history .history').html(historyHtml);

        // Bind all callbacks
        jQuery('.window-modal.window-history .history .callback').off();
        jQuery('.window-modal.window-history .history .callback').click(this.historyCallback.bind(this));
    }

    this.mw.open('history',{closeBtn:true, closeBg:true, closeEsc:true/*, onClose:this.onCloseSettingsWindow*/});

    return false;
};

WebphoneUI.prototype.historyCallback = function(evt) {

    evt.stopPropagation();
    evt.preventDefault();

    var number = jQuery(evt.currentTarget).attr('href').replace('#', '');

    jQuery('.webphone input[name="callee"]').val(number);

    this.evtCall();

    return false;
};



/**
 * Window :: Login
 */
WebphoneUI.prototype.evtOpenLoginWindow = function(evt) {
    this.debug('evtOpenLoginWindow', 'called');

    evt.preventDefault();

    jQuery('.webphone input[name="user"]').val(this.sipLogin);
    jQuery('.webphone input[name="password"]').val(this.sipPassword);

    jQuery('.webphone .window-login form').off();
    jQuery('.webphone .window-login .btn-cancel').off();

    //jQuery('.webphone .window-login input[type="submit"]').click(this.onLoginSubmit.bind(this));
    jQuery('.webphone .window-login form').submit(this.evtLoginSubmit.bind(this));
    jQuery('.webphone .window-login .btn-cancel').click(this.mw.evtCancel.bind(this.mw,['cancel btn']));

    this.mw.open('login',{closeBtn:true, closeBg:true, closeEsc:true, onClose:this.onCloseLoginWindow});

    return false;
};

WebphoneUI.prototype.evtLoginSubmit = function(evt) {
    this.debug('evtLoginSubmit', 'called');

    evt.preventDefault();

    this.sipLogin = jQuery('.window-login input[name="user"]').val();
    this.sipPassword = jQuery('.window-login input[name="password"]').val();

    this.mw.close('login form submit');

    this.login();

    return false;
};

WebphoneUI.prototype.onCloseLoginWindow = function() {
    this.debug('onCloseLoginWindow', 'called');

    jQuery('.webphone .window-login input[type="submit"]').off();
    jQuery('.webphone .window-login .btn-cancel').off();
};



/**
 * Window :: Info
 */
WebphoneUI.prototype.showInfoWindow = function(text, params) {

    this.debug('showInfoWindow', 'called. text= ' + text);

    if (this.mw.isOpenedAndLocked()) {
        this.debug('showInfoWindow', 'is locked, do nothing');
        return;
    }

    jQuery('.webphone .window-info > div').html(text);

    // Fill params
    if (typeof params === 'undefined')
        params = {};

    if (typeof params.closeBg === 'undefined') {
        params.closeBg = true;
    }

    if (typeof params.closeBody === 'undefined') {
        params.closeBody = true;
    }

    if (typeof params.closeEsc === 'undefined') {
        params.closeEsc = true;
    }

    this.mw.open('info',params);
};



/**
 * Window :: Error
 */
WebphoneUI.prototype.showErrorWindow = function(text, params) {

    this.debug('showErrorWindow', 'called. text= ' + text);

    if (this.mw.isOpenedAndLocked()) {
        this.debug('showErrorWindow', 'is locked, do nothing');
        return;
    }

    jQuery('.webphone .window-error > div').html(text);

    // Fill params
    if (typeof params === 'undefined')
        params = {};

    if (typeof params.closeBg === 'undefined') {
        params.closeBg = true;
    }

    if (typeof params.closeBody === 'undefined') {
        params.closeBody = false;
    }

    if (typeof params.closeEsc === 'undefined') {
        params.closeEsc = true;
    }

    if (typeof params.closeBtn === 'undefined') {
        params.closeBtn = true;
    }

    this.mw.open('error', params);
};



/**
 * Window :: Incoming
 */
WebphoneUI.prototype.showIncomingWindow = function(vLineId, callerId) {

    jQuery('.webphone .window-incoming .number').html(callerId);

    // Save caller id
    this.vl(vLineId).callee = callerId;

    jQuery('.webphone .window-incoming .btn-accept').off();
    jQuery('.webphone .window-incoming .btn-reject').off();

    jQuery('.webphone .window-incoming .btn-accept').click(this.evtIncomingAccept.bind(this, vLineId));
    jQuery('.webphone .window-incoming .btn-reject').click(this.evtIncomingReject.bind(this, vLineId));

    this.mw.open('incoming',{closeBtn:true, closeBg:true, closeEsc:true, onCancel:this.evtIncomingCloseWindow.bind(this, vLineId)});
};

WebphoneUI.prototype.evtIncomingAccept = function(vLineId, evt) {

    this.debug('evtIncomingAccept', 'called. vLineId= ' + vLineId);

    var _this = this;

    evt.stopPropagation();

    var vLineState = this.phone.getState(vLineId);

    this.mw.close('incoming btn accept')
        .then(function() {

            // Stop playing any sound
            _this.phone.playSound();

            if (vLineState === 'incoming') {
                // Switch line
                if (vLineId !== _this.phone.getActiveVLineId())
                    _this.phone.selectVLine(vLineId);
                
	        _this.phone.answer(vLineId);

            } else {
                _this.warn('evtIncomingAccept', 'Invalid state= ' + vLineState);
            }
        });

    return false;
};

WebphoneUI.prototype.evtIncomingReject = function(vLineId, evt) {

    this.debug('evtIncomingReject', 'called. vLineId= ' + vLineId);

    var _this = this;

    if (evt)
        evt.stopPropagation();

    this.mw.close('incoming btn reject')
        .then(function() {
            // Stop playing any sound
            _this.phone.playSound();

	    _this.phone.terminateSession(vLineId);
        });

    return false;
};

WebphoneUI.prototype.evtIncomingCloseWindow = function(vLineId, evt) {

    if (evt)
        evt.stopPropagation();

    // Stop playing any sound
    this.phone.playSound();

    return false;
};



/**
 * Window :: Outgoing
 */
WebphoneUI.prototype.showOutgoingWindow = function() {

    jQuery('.webphone .window-outgoing .btn-cancel').click(this.evtOutgoingCancel.bind(this));

    this.mw.open('outgoing',{closeBg:true, closeEsc:true, onCancel:this.evtOutgoingCancel.bind(this)});
};

WebphoneUI.prototype.evtOutgoingCancel = function(evt) {

    this.debug('evtOutgoingCancel', 'called');

    this.mw.close('outgoing btn cancel')
        .then(function() {
	    _this.phone.terminateSession();
        });

    return false;
};



/**
 * Window :: Transfer
 */
WebphoneUI.prototype.showTransferWindow = function(cid) {

    jQuery('.webphone .window-transfer .btn-transfer-attended').off();
    jQuery('.webphone .window-transfer .btn-transfer-blind').off();
    jQuery('.webphone .window-transfer .btn-transfer-finish').off();

    jQuery('.webphone .window-transfer .btn-transfer-attended').click(this.evtTransferAttended.bind(this));
    jQuery('.webphone .window-transfer .btn-transfer-blind').click(this.evtTransferBlind.bind(this));
    jQuery('.webphone .window-transfer .btn-transfer-finish').click(this.evtTransferFinish.bind(this));

    // Clear error field
    jQuery('.webphone .window-transfer p.error').text('');

    this.mw.open('transfer',{closeBtn:true, closeBg:true, closeEsc:true});
};

WebphoneUI.prototype.evtTransferAttended = function(evt) {

    var _this = this;

    this.debug('evtTransferAttended', 'called');

    evt.stopPropagation();

    var number = jQuery('.webphone .window-transfer input[name="number"]').val();

    if (!number.length) {
        jQuery('.webphone .window-transfer p.error').text(this.translate('E_CalleeIsEmpty'));
        return false;
    }

    if (!number.match(/^\*?\d+$/g)) {
        jQuery('.webphone .window-transfer p.error').text(this.translate('E_CalleeIsNotNumber'));
        return false;
    }

    this.debug('evtTransferAttended', "transfer attended to '" + number + "'");

    // Find a free line
    var dstVLineId = this.phone.getAndOccupyVLineId();
    //var session = this.phone.getFreeVLineSession();

    if (!dstVLineId) {
    //if (!session) {
        jQuery('.webphone .window-transfer p.error').text(this.translate('E_NoFreeVLine'));
        return false;
    }

    if (this.phone.getState() === 'talk')
        this.phone.hold();

    this.doingTransfer = {
        'srcVLineId' : this.phone.getActiveVLineId(),
        'dstVLineId' : dstVLineId,
    };

    // Change vline
    this.phone.selectVLine(dstVLineId);

    this.vl(dstVLineId).callee = number;
    this.vl(dstVLineId).inTransfer = true;

    this.phone.call(number);

    this.mw.close('transfer attended');

    return false;
};

WebphoneUI.prototype.evtTransferBlind = function(evt) {

    this.debug('evtTransferBlind', 'called');

    var _this = this;

    evt.stopPropagation();

    var number = jQuery('.webphone .window-transfer input[name="number"]').val();

    if (!number.length) {
        jQuery('.webphone .window-transfer p.error').text(this.translate('E_CalleeIsEmpty'));
        return false;
    }

    if (!number.match(/^\*?\d+$/g)) {
        jQuery('.webphone .window-transfer p.error').text(this.translate('E_CalleeIsNotNumber'));
        return false;
    }

    number = parseInt(number);

    this.debug('evtTransferBlind', "transfer blind to '" + number + "'");

    if (this.phone.getState() === 'talk'
        || this.phone.getState() === 'hold') {
        this.phone.transfer({'dstNumber' : number});
/** /
    } else if (this.phone.getState() === 'incoming') {
        this.phone.answer()
            .then(function(phone) {
                return phone.hold();
            })
            .then(function(phone) {
                return phone.transfer(number);
            });
/**/
    } else {
        throw new Error('E_InvalidSessionState');
    }

    this.mw.close('transfer blind');

    return false;
};

WebphoneUI.prototype.evtTransferFinish = function(evt) {

    this.debug('evtTransferFinish', 'called');

    evt.stopPropagation();

    if (typeof this.doingTransfer === 'object'
        && this.doingTransfer.srcVLineId
        && this.doingTransfer.dstVLineId) {

        this.phone.transfer(this.doingTransfer);

        // Clear all transfer info
        delete this.doingTransfer;

        for (var vLineId = 1; vLineId <= this.maxVLineId; vLineId++)
            this.vl(vLineId).inTransfer = false;
    }

    return false;
};



/**
 * Window :: Access to play audio
 */
WebphoneUI.prototype.openAllowAudioForm = function(audioElement) {
    this.debug('openAllowAudioForm', 'called');

    var _this = this;

    if (audioElement === this.audioSoundPleer) {
        var formSelector = '.window-modal.window-allow-soundpleer';
        var code = 'allow-soundpleer';
        var mw = this.mwAudio;
    } else if (audioElement === this.audioStreamPleer) {
        var formSelector = '.window-modal.window-allow-audiostream';
        var code = 'allow-audiostream';
        var mw = this.mwAudioStream;
    } else {
        this.debug('openAllowAudioForm', 'Unknown audioElement');
        return false;
    }

    //this.mwAudio.close('at allow audio form');

    audioElement.removeEventListener('play', this.allowAudioOnPlayEvent.bind(this));
    audioElement.addEventListener('play', this.allowAudioOnPlayEvent.bind(this));

    jQuery(formSelector).find('.btn-play').off();
    jQuery(formSelector).find('.btn-play').click(function(evt) {
        evt.stopPropagation();

        audioElement.play();
        mw.close('allow audio btn play', true);

        return false;
    });

    mw.open(code, {closeBtn:true, closeBg:true, closeEsc:true});
};

WebphoneUI.prototype.allowAudioOnPlayEvent = function(obj) {
    this.debug('allowAudioOnPlayEvent', 'called');
};



/**
 * Phone events
 */
WebphoneUI.prototype.peRegistered = function() {
    this.debug('peRegistered', 'called');

    this.showInfoWindow(this.translate('M_Registration'), {autoClose:1000});
};

WebphoneUI.prototype.peRegistrationFailed = function(pe) {
    this.debug('peRegistrationFailed', 'called');

    this.showCallErrorWindow(pe.error, {autoClose:3000});
};

WebphoneUI.prototype.peIncoming = function(pe) {
    this.debug('peIncoming', 'called');

    // Any line
    this.vl(pe.vLineId).infoLine = 'Входящий звонок';
    this.vl(pe.vLineId).callStarted = new Date();
    this.vl(pe.vLineId).isIncoming = true;

    this.phone.playSound('ringing', 6);

    // Active line
    if (pe.vLineId === this.phone.getActiveVLineId()) {
        this.updateInfoLine(this.vl().infoLine);
    }

    this.showIncomingWindow(pe.vLineId, pe.callerId);
};

WebphoneUI.prototype.peIncomingFailed = function(pe) {
    this.debug('peIncomingFailed', 'called');

    this.showCallErrorWindow(pe.error, {autoClose:1000});
    this.phone.playSound('rejected');
};

WebphoneUI.prototype.peCallProgress = function(pe) {
    this.debug('peCallProgress', 'called. vLineId= ' + pe.vLineId);

    // Any line
    if (this.vl(pe.vLineId).callStarted === null)
        this.vl(pe.vLineId).callStarted = new Date();
    this.vl(pe.vLineId).infoLine = this.translate('P_Status_Calling');

    // Active line
    if (pe.vLineId === this.phone.getActiveVLineId()) {
        // 2020-03-20 @tknelf
        // Disable ringback, because sip.primatel.ru sends RBT
        //if (this.phone.getState() === 'calling')
        //this.phone.playSound('ringback', 6);
        //

        this.showClock('call');

        this.updateInfoLine(this.vl().infoLine);
    }
};

WebphoneUI.prototype.peCallConfirmed = function(pe) {
    this.debug('peCallConfirmed', 'called');

    // Any line
    this.phone.playSound('answered');

    //this.vl(pe.vLineId).callStarted = null;
    this.vl(pe.vLineId).talkStarted = new Date();

    if (this.vl(pe.vLineId).inTransfer)
        this.vl(pe.vLineId).infoLine = this.vl(pe.vLineId).callee + ', ' + this.translate('P_Status_Transfer');
    else
        this.vl(pe.vLineId).infoLine = this.vl(pe.vLineId).callee + ', ' + this.translate('P_Status_Talk');

    // Clear callee input field
    jQuery('.webphone .screen input[name="callee"]').val('');

    // Active line
    if (pe.vLineId === this.phone.getActiveVLineId()) {
        // 2020-03-20 @tknelf
        // Disable ringback, because sip.primatel.ru sends RBT
        //if (this.phone.getState() === 'calling')
        //this.phone.playSound('ringback', 6);
        //

        this.showClock('talk');

        this.updateInfoLine(this.vl().infoLine);

        this.mw.close('call confirmed event');
    }
};

WebphoneUI.prototype.peCallEnded = function(pe) {
    this.debug('peCallEnded', 'called');

    // Save history
    this.addToHistory(pe.vLineId, 'success');

    // Any line
    this.phone.playSound('answered');

    this.vlClear(pe.vLineId);
    this.vl(pe.vLineId).infoLine = this.translate('P_Status_Done');

    // Active line
    if (pe.vLineId === this.phone.getActiveVLineId()) {
        // 2020-03-20 @tknelf
        // Disable ringback, because sip.primatel.ru sends RBT
        //if (this.phone.getState() === 'calling')
        //this.phone.playSound('ringback', 6);
        //

        this.stopClock();

        this.updateInfoLine(this.vl().infoLine);

        this.showInfoWindow(this.translate('M_CallEnded'), {autoClose:1000});

        jQuery('.webphone input[name="callee"]').val(this.vl(pe.vLineId).callee);
    }
};

WebphoneUI.prototype.peCallFailed = function(pe) {
    this.debug('peCallFailed', 'called');

    this.debug('peCallFailed', 'pe: ' + this.l._dump(pe));

    // Save history
    if (this.vl(pe.vLineId).callStarted === null)
        this.vl(pe.vLineId).callStarted = new Date();

    if (pe.error instanceof CallException
        && this.translate('CallCause_' + pe.error.message) !== 'CallCause_' + pe.error.message)
        this.addToHistory(pe.vLineId, 'fail', pe.error.message);
    else
        this.addToHistory(pe.vLineId, 'fail');

    // Any line
    //if (!this.vl(pe.vLineId).lastFailedSession
    //|| this.vl(pe.vLineId).lastFailedSession !== this.phone.getSession()) {
        this.showCallErrorWindow(pe.error, {autoClose:2000, lock:true});
        this.phone.playSound('rejected');
    //} else {
    //this.debug('peCallFailed', 'Already shown failure message for this session');
    //}

    this.vlClear(pe.vLineId);

    if (pe.error instanceof CallException) {
        if (this.translate('CallCause_' + pe.error.message) !== 'CallCause_' + pe.error.message)
            this.vl(pe.vLineId).infoLine = this.translate('CallCause_' + pe.error.message);
        else
            this.vl(pe.vLineId).infoLine = this.translate('P_Status_CallFailed');
    } else
        this.vl(pe.vLineId).infoLine = this.translate('P_Status_CallFailed');

    // Active line
    if (pe.vLineId === this.phone.getActiveVLineId()) {
        // 2020-03-20 @tknelf
        // Disable ringback, because sip.primatel.ru sends RBT
        //if (this.phone.getState() === 'calling')
        //this.phone.playSound('ringback', 6);
        //

        this.stopClock();

        this.updateInfoLine(this.vl().infoLine);

        this.showInfoWindow(this.translate('M_CallEnded'), {autoClose:1000});

        jQuery('.webphone input[name="callee"]').val(this.vl(pe.vLineId).callee);
    }
};

WebphoneUI.prototype.peCallHold = function(pe) {
    this.debug('peCallHold', 'called');

    // Any line
    this.vl(pe.vLineId).holdStarted = new Date();
    this.vl(pe.vLineId).infoLine = this.vl(pe.vLineId).callee + ', ' + this.translate('P_Status_Hold');

    // Active line
    if (pe.vLineId === this.phone.getActiveVLineId()) {
        this.showClock('hold');

        this.updateInfoLine(this.vl().infoLine);
    }
};

WebphoneUI.prototype.peCallUnhold = function(pe) {
    this.debug('peCallUnhold', 'called');

    // Any line
    this.vl(pe.vLineId).holdStarted = null;
    this.vl(pe.vLineId).infoLine = this.vl(pe.vLineId).callee + ', ' + this.translate('P_Status_Talk');

    // Active line
    if (pe.vLineId === this.phone.getActiveVLineId()) {
        this.showClock('talk');

        this.updateInfoLine(this.vl().infoLine);
    }
};

WebphoneUI.prototype.peStateChanged = function(pe) {
    this.debug('peStateChanged', 'called');

    // Log state changes
    jQuery('.debug .state ul').prepend('<li><span class="time">' + this.l._currentTimeString() + '</span><span class="message">' + pe.vLineId + ' : ' + pe.prevState + ' &#x2192; '  + pe.state + '</span></li>');
    //this.vl(pe.vLineId).updatedToState = pe.state;

    this.updateUI();
};

WebphoneUI.prototype.peVLineSelected = function(pe) {
    this.debug('peVLineSelected', 'called');

    jQuery('.webphone .vlines li').removeClass('selected');
    jQuery('.webphone .vlines li:nth-child(' + pe.vLineId + ')').addClass('selected');

    this.updateUI();

    // Set focus on callee input if status is ready
    var state = this.phone.getState(pe.vLineId);
    //this.debug('peVLineSelected', 'state= ' + state);
    if (state === 'ready') {
        //this.debug('peVLineSelected', 'set focus');
        jQuery('.webphone .screen input[name="callee"]').focus();
    }
};

WebphoneUI.prototype.peAudioNotAllowed = function(pe) {
    this.openAllowAudioForm(pe.audio);
};

WebphoneUI.prototype.peWebSocketFailed = function(error) {
    this.debug('peWebSocketFailed', 'called');

    this.debug('peWebSocketFailed', 'WebSocket error dump: ' + this.l._dump(error));
    //this.l.logerror('dump WebSocket, error2: ', error);

    var httpsUri = 'wss://webrtc.primatel.ru:8089'.replace(/wss:\/\//, 'https://');

    this.showErrorWindow(this.translate('E_WebSocketFailed') + '<a target="_blank" href="' + httpsUri + '">' + httpsUri + '</a>');

    this.phone.logout();
};

WebphoneUI.prototype.showCallErrorWindow = function(error, params) {

    if (error instanceof CallException) {
        if (this.translate('CallCause_' + error.message) != 'CallCause_' + error.message) {
            this.showInfoWindow(this.translate('CallCause_' + error.message), params);
        } else {
            this.showInfoWindow(error.message, params);
        }
    } else if (error instanceof RegistrationException) {
        if (this.translate('RegistractionCause_' + error.message) != 'RegistractionCause_' + error.message) {
            this.showInfoWindow(this.translate('RegistractionCause_' + error.message), params);
        } else {
            this.showInfoWindow(error.message, params);
        }
    } else if (error instanceof NoAccessMicrophoneException) {
        this.showInfoWindow(this.translate('E_NoAccessMicrophone'), params);
    } else if (typeof error.message !== 'undefined') {
        this.showInfoWindow(error.message, params);
    } else {
        this.showInfoWindow(this.translate('E_Unknown'), params);
    }

    /*
    if (typeof err.name !== 'undefined')
        this.showInfoWindow(this.translate('UserMediaException_'+err.name), {autoClose:3000, lock: true});
    else
        this.showInfoWindow(this.translate('E_NoAccessMicrophone'), {autoClose:3000, lock: true});
*/
};


/**
 * Init & bind
 */
WebphoneUI.prototype.init = function() {
    this.debug('init', 'called');

    var _this = this;

    // Fix for all objects use the same logger object
    // FIXME Rewrite to do this on objects instantiate?
    if (typeof this.phone.l !== 'undefined')
        this.phone.l = this.l;

    if (typeof this.mw.l !== 'undefined')
        this.mw.l = this.l;

    if (typeof this.mwAudio.l !== 'undefined')
        this.mwAudio.l = this.l;

    if (typeof this.mwAudioStream.l !== 'undefined')
        this.mwAudioStream.l = this.l;

    this.translateBlock('.webphone');

    if (jQuery('.webphone .window-settings input[name="debugmode"]').prop('checked')) {
        JsSIP.debug.enable('JsSIP:*');
        this.l.enabled = true;
        this.debug('init', 'debugmode enabled');
    } else {
        this.debug('init', 'debugmode disabled');
        JsSIP.debug.disable('JsSIP:*');
        this.l.enabled = false;
    }


    this.phone.addEventListener('registered', this.peRegistered.bind(this));
    this.phone.addEventListener('registrationfailed', this.peRegistrationFailed.bind(this));
    this.phone.addEventListener('incoming', this.peIncoming.bind(this));
    this.phone.addEventListener('incomingfailed', this.peIncomingFailed.bind(this));
    this.phone.addEventListener('callprogress', this.peCallProgress.bind(this));
    this.phone.addEventListener('callconfirmed', this.peCallConfirmed.bind(this));
    this.phone.addEventListener('callended', this.peCallEnded.bind(this));
    this.phone.addEventListener('callfailed', this.peCallFailed.bind(this));
    this.phone.addEventListener('callhold', this.peCallHold.bind(this));
    this.phone.addEventListener('callunhold', this.peCallUnhold.bind(this));
    this.phone.addEventListener('statechanged', this.peStateChanged.bind(this));
    this.phone.addEventListener('vlineselected', this.peVLineSelected.bind(this));
    this.phone.addEventListener('audionotallowed', this.peAudioNotAllowed.bind(this));
    this.phone.addEventListener('websocketfailed', this.peWebSocketFailed.bind(this));

    this.audioSoundPleer = jQuery('.webphone .window-allow-soundpleer audio').get()[0];
    this.phone.setSoundPleerAudioObject(this.audioSoundPleer);

    this.audioStreamPleer = jQuery('.webphone .window-allow-audiostream audio').get()[0];
    this.phone.setAudioStreamPleerAudioObject(this.audioStreamPleer);

    // Header links
    jQuery('.webphone .header .btn-login').click(this.evtOpenLoginWindow.bind(this));

    jQuery('.webphone .header .btn-logout').click(this.evtLogout.bind(this));

    // Virtual lines
    jQuery('.webphone .vlines li').click(this.evtSelectLine.bind(this));

    // Screen
    // Bind call on press enter
    jQuery('.webphone input[name="callee"]').keypress(function(evt) {
        if ( evt.which == 13 ) {
            _this.evtCall.apply(_this,[evt]);
            event.preventDefault();
            return false;
        }
    });

    // On screen buttons
    jQuery('.webphone .btn-mic').click(this.evtClickMicBtn.bind(this));
    jQuery('.webphone .btn-hold').click(this.evtClickHoldBtn.bind(this));
    jQuery('.webphone .btn-transfer').click(this.evtClickTransferBtn.bind(this));
    jQuery('.webphone .btn-history').click(this.evtOpenHistoryWindow.bind(this));
    jQuery('.webphone .btn-settings').click(this.evtOpenSettingsWindow.bind(this));

    // Keypad
    jQuery('.webphone .keypad > .n').click(this.evtClickKeypad.bind(this));
    jQuery('.webphone .btn-clr').click(this.evtClickBackspace.bind(this));

    jQuery('.webphone .btn-call').click(this.evtCall.bind(this));

    jQuery('.webphone .btn-hangup').click(this.evtHangup.bind(this));



    // Try to close all sessions before page unload, refresh, etc.
    window.addEventListener('beforeunload', function() {
        _this.phone.logout();
        _this.saveHistory();
    });

    // Periodically save call history
    setInterval(function() {
        if (_this.callHistoryChanged) {
            _this.saveHistory();
        }
    }, 10 * 1000);

    // Simulate a callback from webphone lib in order to update UI properly
    this.peVLineSelected({vLineId:1});
};



WebphoneLogger.addLoggerMethods(WebphoneUI, 'WebphoneUI');
